// src/context/ThemeContext.js
import React, {createContext, useContext, useState} from "react";

const AnimatedLeafContext = createContext({
    animatedLeaf: true, toggleAnimated: () => {
    }
});

export const AnimatedProvider = ({children}) => {
    const [animatedLeaf, setAnimatedLeaf] = useState(true)

    const toggleAnimated = () => {
        setAnimatedLeaf((prev) => !prev);
    };

    return (
        <AnimatedLeafContext.Provider value={{animatedLeaf, toggleAnimated}}>
            {children}
        </AnimatedLeafContext.Provider>
    );
};

export const useAnimated = () => useContext(AnimatedLeafContext);
